import {
  SerializedError,
  createEntityAdapter,
  EntityState,
} from '@reduxjs/toolkit';

import { AppError } from '@vk-hr-tek/core/error';
import { Filter } from '@vk-hr-tek/core/filter';

import { RequestStatus } from '@app/types';
import {
  CreateSimpleEventTypeCompany as EventTypeCompany,
  CreateSimpleEventTypeOptionsResponse as EventTypeOptions,
  EventListItem,
} from '@app/gen/events';
import { RootState } from '@app/store';

export interface ReviewState {
  status: RequestStatus;
  currentIds: string[];
  total: number;
  totalMy?: number;
  totalMyTeam?: number;
  finished: number;
  error: AppError | null;
  filters: {
    data: Filter[] | null;
    id: string;
  };
  eventTypes: {
    companies: (EventTypeCompany & EventTypeOptions)[];
    status: RequestStatus;
    error: AppError | null;
  };
}

export interface ReviewWithRootState extends RootState {
  review: ReviewState & EntityState<EventListItem, string>;
}

export const initialState: ReviewState = {
  status: 'idle',
  currentIds: [],
  total: 0,
  totalMy: undefined,
  totalMyTeam: undefined,
  finished: 0,
  error: null,
  filters: {
    data: null,
    id: '',
  },
  eventTypes: {
    companies: [],
    status: 'idle',
    error: null,
  },
};

export const startLoading = (state: ReviewState) => {
  state.status = 'loading';
  state.error = null;
  state.total = 0;
  state.finished = 0;
  state.currentIds = [];
};

export const completeLoading = (state: ReviewState) => {
  state.status = 'complete';
  state.error = null;
};

export const setError = (
  state: ReviewState,
  { payload, error }: { payload?: AppError; error: SerializedError },
) => {
  state.status = 'failed';
  state.error =
    payload ||
    ({
      info: (error && error.message) || 'Unknown error',
      status: 500,
      source: 'client',
      title: 'Internal client error',
    } as AppError);
};

export const reviewAdapter = createEntityAdapter<EventListItem>();
